import { observer } from 'mobx-react-lite'
import { type JobManagementViewModel } from '@/features/jobs/list/JobManagementViewModel'
import { DisplayMenu, type DisplayMenuOption } from './DisplayMenu'

export interface DisplayMenuContainerProps {
  vm: JobManagementViewModel
}

export const DisplayMenuContainer = observer(function DisplayMenuContainer({
  vm,
}: DisplayMenuContainerProps) {
  const list = vm.jobListPageVm
  const searcher = vm.searcher
  const tabsVm = list.tabsVm
  return (
    <DisplayMenu
      section={list.displaySection}
      onSectionChange={list.setDisplaySection}
      tabs={tabsVm.allTabs.map((tab) => ({
        id: tab.id,
        name: tab.name,
        isDefault: tab.isDefault,
        isShown: !tab.isHidden,
        canChange: tabsVm.canRemove(tab.id),
        onToggle: () => tabsVm.toggleHidden(tab.id),
        onDelete: () => tabsVm.requestDelete(tab.id),
      }))}
      deletedTabs={tabsVm.deletedDefaults}
      onAddBack={tabsVm.addBack}
      onMoveTab={tabsVm.move}
      onResetTabs={tabsVm.requestReset}
      onNewTab={tabsVm.canAddTab ? tabsVm.newTab : undefined}
      scopeOptions={
        searcher.showSearchScopeFilter
          ? segmentOptions(searcher.scope, searcher.setScope, [
              ['Mine', 'My jobs'],
              ['All', 'All jobs'],
            ])
          : null
      }
      periodOptions={segmentOptions(
        searcher.jobPeriodOption,
        searcher.setJobPeriod,
        [
          ['All', 'All'],
          ['Current', 'Current'],
          ['Old', 'Older'],
        ],
      )}
      archivedOptions={
        vm.selectionVm.canViewArchivedJobs
          ? segmentOptions(
              vm.archivedJobsFilter.value,
              vm.archivedJobsFilter.setValue,
              [
                [false, 'Hide'],
                [true, 'Only archived'],
              ],
            )
          : null
      }
      columns={list.tableColumns.map((column) => ({
        id: column.id,
        header: column.header(list.perspective),
        isVisible: list.isVisible(column),
        isLocked: Boolean(column.locked),
        onToggle: () => list.toggleColumn(column.id),
      }))}
      onMoveColumn={list.moveListedColumn}
      onResetColumns={list.resetColumns}
    />
  )
})

function segmentOptions<T>(
  selected: T,
  onChange: (value: T) => unknown,
  options: [value: T, label: string][],
): DisplayMenuOption[] {
  return options.map(([value, label]) => ({
    label,
    isSelected: value === selected,
    onSelect: () => onChange(value),
  }))
}
